import React from 'react';
import Card, { CardTitle } from '../../components/Card';
import Styles from './dashboardStyle.module.scss';
import { LoaderCircle } from 'lucide-react';

const ComplianceStatus = ({ compliancesInfo }) => {
  // console.log(compliancesInfo);

  return (
    <Card className={Styles['compliance-card']}>
      <CardTitle title="Compliance Status" />

      {!compliancesInfo ? (
        <div>
          <LoaderCircle className="animate-spin w-10 h-10 text-white" />
        </div>
      ) : (
        <>
          <div className={Styles['compliance-percent']}>
            {compliancesInfo.totalDevices?.value > 0
              ? `${Math.floor((compliancesInfo.compliance?.value / compliancesInfo.totalDevices?.value) * 100)}%`
              : 'N/A'}
          </div>
          <div className={Styles['compliance-change']}>
            {compliancesInfo.previousComplianceScore
              ? `${compliancesInfo.currentComplianceScore > compliancesInfo.previousComplianceScore ? ' +' : ' -'}${Math.round(
                  ((compliancesInfo.currentComplianceScore - compliancesInfo.previousComplianceScore) /
                    compliancesInfo.previousComplianceScore) *
                    100,
                )}% from last week`
              : ''}
          </div>
        </>
      )}
    </Card>
  );
};
export default ComplianceStatus;
